<template>
    <div class="custom-person" v-if="sourceList.length">
        <div class="title">{{ title }}</div>
        <div class="content-wrap">
            <div class="content-item" :class="{'last-content-item':last,'last-odd':last && isLastOdd === 1 && index ===  sourceList.length - 2}" v-for="(item,index) in sourceList" :key="index">
                <img :src="item.icon" alt="">
                <div class="text">
                    <span v-for="va in item.text" :key="va">{{ va }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "custom-person",
    props: {
        // 标签标题
        title: String,
        /**
         * 渲染列表
         * @type { array<{icon:string; text:[string]}> }
         */
        sourceList: {
            type: Array,
            default: () => []
        },
        // 最后一个元素项
        last: Boolean,
    },
    computed: {
        isLastOdd() {
            return Math.round(this.sourceList.length % 2)
        }
    }
}
</script>

<style scoped lang="scss">
.custom-person {
    .title {
        padding: 0 28px;
        height: 56px;
        line-height: 56px;
        background: $defaultGreen;
        font-size: $baseSize;
        color: #FFFFFF;
        border-radius: 50px;
        width: max-content;
        margin-bottom: 32px;
    }

    .content-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .content-item {
            flex: 0 0 48%;
            display: flex;
            align-items: center;
            margin-bottom: 40px;

            img {
                flex: 0 0 auto;
                width: 84px;
                height: 84px;
                margin-right: 10px;
            }

            .text {
                flex: 1;
                font-size: 26px;
            }
        }

        .last-content-item:nth-last-child(1), .last-content-item:nth-last-child(2) {
            margin-bottom: 0;
        }


        .last-odd {
            margin-bottom: 40px!important;
        }
    }
}
</style>
